// Script pour gérer les codes promo dans le panier
document.addEventListener('DOMContentLoaded', function() {
  // Éléments du DOM
  const promoForm = document.getElementById('CartDrawer-PromoForm');
  const promoInput = document.getElementById('CartDrawer-PromoCode');
  const promoLoader = document.querySelector('.promo-loader');
  const promoCodeApplied = document.querySelector('.promo-code-applied-mini');
  
  // Fonction pour afficher/masquer l'animation de chargement
  function toggleLoader(show) {
    if (promoLoader) {
      promoLoader.style.display = show ? 'flex' : 'none';
    }
  }

  // Fonction pour créer et afficher un message
  function showMessage(message, isError = false) {
    // Supprimer tout message existant
    const existingMessage = document.querySelector('.promo-message');
    if (existingMessage) {
      existingMessage.remove();
    }
    
    // Créer un nouvel élément de message
    const messageEl = document.createElement('div');
    messageEl.className = `promo-message ${isError ? 'promo-error' : 'promo-success'}`;
    messageEl.textContent = message;
    
    // Ajouter le message après le formulaire
    if (promoForm) {
      promoForm.parentNode.insertBefore(messageEl, promoForm.nextSibling);
    } else if (promoCodeApplied) {
      promoCodeApplied.parentNode.insertBefore(messageEl, promoCodeApplied.nextSibling);
    }
    
    // Supprimer le message après 5 secondes
    setTimeout(() => {
      messageEl.remove();
    }, 5000);
  }

  // Fonction pour appliquer un code promo
  function applyDiscountCode(code) {
    toggleLoader(true);
    // Utiliser la méthode de redirection standard de Shopify mais en restant dans le cart drawer
    // C'est la méthode la plus fiable pour appliquer un code promo
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + window.location.pathname;
  }

  // Fonction pour supprimer un code promo
  function removeDiscountCode() {
    toggleLoader(true);
    // Utiliser la méthode de redirection standard de Shopify mais en restant dans le cart drawer
    window.location.href = '/discount/clear?redirect=' + window.location.pathname;
  }

  // Gestionnaire d'événements pour le formulaire de code promo
  if (promoForm) {
    promoForm.addEventListener('submit', function(e) {
      e.preventDefault();
      
      // Vérifier si le code est vide
      const code = promoInput.value.trim();
      if (!code) return;
      
      // Appliquer le code promo
      applyDiscountCode(code);
    });
  }

  // Gestionnaire d'événements pour le bouton de suppression de code promo
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('remove-promo-code-mini') || e.target.closest('.remove-promo-code-mini')) {
      e.preventDefault();
      removeDiscountCode();
    }
  });
});
